import { configureStore } from "@reduxjs/toolkit";
import userReducer from '../reducers/userSlice';
import { createStore, combineReducers } from "redux";

/*
export default configureStore({

    reducer:{
        user:userReducer
    }
})*/

const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
};

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (e) {
        // Ignore write errors;
    }
};

const persistedState = loadState();

const reducers = combineReducers({
    user: userReducer,
});

const store = createStore(reducers, persistedState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

store.subscribe(() => {
    saveState(store.getState());
});

export default store;